export const watch = {
  pendingGlTransactionDetails(value) {
    console.log('pendingGlTransactionDetails', value)
  }
}
